import dayjs from 'dayjs';

import constants from './constants';

function updateVehicle({ license_plate, values }) {

  return (dispatch, getState) => {

    const { [license_plate]: plate } = getState().socket || {};

    const { time: currentTime } = plate || {};
    const { time: newTime } = values || {};
    const shouldUpdate = currentTime && newTime ? dayjs(newTime)
      .isAfter(dayjs(currentTime)) : true;

    if (!shouldUpdate) return;

    dispatch({
      type: constants.SOCKET_UPDATE_VEHICLE,
      payload: {
        [license_plate]: { ...plate, ...values },
      },
    });

  };

}

function updateMultiplesVehicles(vehiclesData) {

  return (dispatch, getState) => {

    const socketVehicles = getState().socket;
    const newSocketData = { ...socketVehicles };

    vehiclesData.forEach((vehicle) => {

      const { license_plate } = vehicle;

      if (!(license_plate in newSocketData)) {

        newSocketData[license_plate] = vehicle;

      }

    });

    dispatch({
      type: constants.SOCKET_UPDATE_ALL_VEHICLES,
      payload: newSocketData,
    });

  };

}

export default { updateVehicle, updateMultiplesVehicles };
